export default __webpack_public_path__ + "static/media/notif_shared_request.530bba49.svg";